export default __webpack_public_path__ + "static/media/logo.34b654d2.svg";